import { DomainStatus, SyncStatus } from '../types';

export type DisplayStatus = 'active' | 'learning' | 'inactive' | 'error';

export function getDomainDisplayStatus(
  status: DomainStatus,
  syncStatus: SyncStatus | null
): DisplayStatus {
  // (1) inactive 最優先
  if (status === 'inactive') return 'inactive';
  // (2) syncing / pending → 学習中
  if (syncStatus === 'syncing' || syncStatus === 'pending') return 'learning';
  // (3) synced + active → 稼働中
  if (syncStatus === 'synced' && status === 'active') return 'active';
  // (4) error / failed / null → エラー
  if (syncStatus === 'error' || syncStatus === 'failed' || syncStatus === null) return 'error';
  // (5) その他
  return 'error';
}
